<template>
  <Content stretch>
    <slot>no Paired Association component specified</slot>
  </Content>
</template>

<script>
import { Content } from '@neurotrack/web-shared-components'
import essExamProps from '@/mixins/essExamProps'

export default {
  name: 'exam_paired_association',
  components: { Content },
  mixins: [essExamProps],
  watch: {
    isExamComplete(complete) {
      if (complete) {
        this.completeExam()
      }
    }
  },
  methods: {
    completeExam() {
      this.$store.dispatch(`exam/${this.exam}/complete`, undefined, {
        root: true
      })
    },
    trackEvent(perception) {
      this.$store.dispatch(`exam/${this.exam}/trackEvent`, perception, {
        root: true
      })
    },
    handleResponse({ event }) {
      this.trackEvent(event)
      this.$emit('next')
    }
  }
}
</script>

<style scoped></style>
